import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import ScopeDocuments from "@/components/rd/ScopeDocuments";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ProjectScope() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const load = async () => {
    setError("");
    try {
      const { data } = await api.get("/rd/documents");
      if (!Array.isArray(data)) throw new Error("Unexpected document response");
      setDocuments(data);
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail || err.message));
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  const visible = documents.filter(d => d.filename.toLowerCase().includes(query.trim().toLowerCase()));
  return (
    <Layout>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="text-3xl font-bold text-brand-800">Project Scope</h1>
        <p className="mt-2 mb-6 text-stone-600">Upload and keep your client briefs and project scopes here. You do not need to create a formula or fill out a scope form first.</p>
        {error && <div role="alert" className="mb-4 rounded border border-red-200 bg-red-50 p-3 text-red-800">
          Could not refresh your documents. {error} <Button variant="outline" onClick={load}>Retry</Button>
        </div>}
        <label className="block text-sm text-stone-600 mb-4">
          Find a brief or scope
          <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search filenames"
            className="block mt-1 w-full rounded border border-stone-300 p-2 focus:ring-2 focus:ring-brand-800"
            data-testid="scope-library-search" />
        </label>
        {loading ? <p role="status">Loading your documents…</p> :
          <ScopeDocuments library documents={visible} onReload={load} />}
        {!loading && query && visible.length === 0 && <p className="text-sm text-stone-600">No documents match this search.</p>}
      </main>
    </Layout>
  );
}
